import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=c09b57e4&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "@/assets/font/info/iconfont.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MessageCenter.vue?vue&type=style&index=1&id=c09b57e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09b57e4",
  null
  
)

export default component.exports